import { render, staticRenderFns } from "./ScrollableButtons.vue?vue&type=template&id=980a11d6&scoped=true"
import script from "./ScrollableButtons.vue?vue&type=script&lang=ts"
export * from "./ScrollableButtons.vue?vue&type=script&lang=ts"
import style0 from "./ScrollableButtons.vue?vue&type=style&index=0&id=980a11d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "980a11d6",
  null
  
)

export default component.exports